import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-teste-deploy',
  templateUrl: './teste-deploy.component.html',
  styleUrls: ['./teste-deploy.component.scss']
})
export class TesteDeployComponent implements OnInit {
  versao: string = 'v2026.08.31-1';
  dataDeploy: string = '31/08/2026 13:40';
  ambiente: string = 'Stage (Azure App Service)';

  ngOnInit(): void {}
}
